import $api from '../../utils/api.js'


const state = () => ({
    tag: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        type:'',
        sort:'desc',
        placeholder:'Search Tag'
    },
    formdata:{
        id:'',
        name:'',
        image_cover_url:'',
        meta_keywords:'',
        meta_description:'',
        meta_title:'',
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.tag = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            name:payload.name,
            image_cover_url:payload.image_cover_url,
            meta_keywords:payload.meta_keywords,
            meta_description:payload.meta_description,
            meta_title:payload.meta_title,
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            name:'',
            image_cover_url:'',
            meta_keywords:'',
            meta_description:'',
            meta_title:'',
        },
        state.errors = []
    },
    CLEAR_CATEGORY(state){
        state.tag = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        },
        state.sorting =  {
            num:10,
            search: '',
            offset: 4,
            type:'',
            sort:'desc',
            placeholder:'Search Tag'
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getTag({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`tag?type=${state.sorting.type}&page=${state.tag.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}&sort=${state.sorting.sort}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createTag({ commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`tag`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    editTag({ commit }, payload) {
        return new Promise((resolve) => {
            $api.get(`tag?id=${payload}`)
            .then((response) => {
                commit('ASSIGN_FORM', response.data)
                resolve(response.data)
            })
        })
    },
    updateTag({ state,commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`tag/${state.formdata.id}`, payload.formData)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    deleteTag({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`tag/${payload}`)
            .then(() => {
                dispatch('getTag').then(() => resolve())
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}